<template>
    <Popup ref="popup" :animation="'scale'">
        <div class="modal-container">
            <div class="modal-bg">
                <img :src="_global.assetsRoot + '/bonus_status_close.png'" alt="Close" class="close-btn" @click="hide"
                    aria-label="Close" />

                <div class="modal-header">
                    <h1 class="title-header">{{ modalTitle }}</h1>
                </div>

                <div class="modal-body">
                    <h2>{{ content }}</h2>
                </div>

                <div class="action-btn-wrapper" @click="performAction">
                    <img :src="_global.assetsRoot + '/bonus_status_button.png'" alt="Action Button"
                        class="action-btn-img" />
                    <span class="action-btn-text">{{ continueButtonText }}</span>
                </div>
            </div>
        </div>
    </Popup>
</template>



<script>
import Popup from '../Popup.vue';
import messages from '../../i18n';

export default {
    data() {
        return {
            modalTitle: "",
            content: "",
            continueButtonText: "",
            bonusStatus: ""
        };
    },
    mounted() {
        this.bonusStatus = this._global.extra.bonus_status;
        this.setLanguageContent();
        /*if (['expired', 'not_available'].includes(this.bonusStatus)) {
            this.show();
        }*/
    },
    methods: {
        show() {
            this.$refs.popup.show();
        },
        hide() {
            this.$refs.popup.hide();
        },
        performAction() {
            console.log("Action performed");
            this.hide();
        },
        setLanguageContent() {
            const userLang = this._global.user.lang || 'en';
            const langMessages = messages[userLang] && messages[userLang].message ? messages[userLang].message : messages['en'].message;

            this.modalTitle = langMessages.bonusModalTitle;
            this.continueButtonText = langMessages.bonusContinueButton;

            switch(this.bonusStatus){
                case 'expired':
                    this.content = langMessages.bonusExpired || 'Bonus expired.';
                    break;
                case 'not_available':
                    this.content = langMessages.bonusNotAvailable || 'Bonus already claimed.';
                    break;
                case 'not_found':
                    this.content = langMessages.bonusNotFound || 'Bonus is not active.';
                    break;
                default:
                    this.content = '';
                    break;
            }
        }
    },
    components: {
        Popup
    }
};
</script>


<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Khand:wght@700&display=swap');

.modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.modal-bg {
    position: relative;
    width: 90%;
    max-width: 600px;
    background-image: url($assetRoot + "/bonus_status_bg.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 20px;
    padding: 20px 20px 40px;
}

.modal-header {
    display: flex;
    justify-content: center;
    // padding: 10px 0 0;
}

.title-header {
    font-family: 'Khand',sans-serif;
    font-size: 90px;
    color: #ffd200;
    position: relative;
    top: -90px;
    // letter-spacing: 2px;
    margin: 0;
    text-align: center;
    z-index: 10;
    -webkit-text-stroke: 4px #ad146e;
}

.close-btn {
    position: absolute;
    top: -15px;
    right: 0px;
    width: 70px;
    height: 70px;
    cursor: pointer;
    z-index: 15;
}

.modal-body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 500;
    font-size: 30px !important;
    text-align: center;
    color: #ffff;
    padding: 0px;
    position: relative;
    top: -60px;
}



.action-btn-wrapper {
    position: relative;
    display: block;
    width: 200px;
    height: 50px;
    margin: 0px auto 20px;
    cursor: pointer;
}

.action-btn-img {
    width: 200px;
    height: 70px;
    background-size: contain;
    background-position: center;
}

.action-btn-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffff;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    z-index: 10;
}


@media (max-width: 768px) {
    .modal-bg {
        width: 95%;
        max-width: 350px;
        margin: 0 25px;
    }

    .modal-body {
        font-size: 17px !important;
        top: -25px;
    }

    .title-header {
        font-size: 44px;
        top: -4vh;
        -webkit-text-stroke: 2px #ad146e;
    }

    .action-btn-wrapper {

        height: 40px;
    }

    .action-btn-text {
        font-size: 18px;
    }

    .close-btn {
        width: 45px;
        height: 45px;
        top: 4px;
        right: -4px;
    }

    .action-btn-img {
        height: 50px;
        width: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/popup/Bonus.vue